<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0 pt-2">

        <v-card-title class="headline">
          Ostrzeżenie
        </v-card-title>

        <v-card-text>
          <p>
            Ważność Twojego konta wygaśnie
            za <span v-text="plural(daysToExpire, ['%d dzień', '%d dni', '%d dni'])"></span>.
          </p>
          <p>Skontaktuj się z Administratorem aby przedłużyć subskrybcję.</p>
        </v-card-text>

        <v-card-actions class="px-4 py-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="closeDialog"
          >
            Zamknij
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getPlural } from '../../../helpers/helpers';

export default {
  name: 'account-expiration',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('dashboard-client', [
      'dialogVisibility',
      'daysToExpire',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility === 'account-expiration';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('dashboard-client', [
      'setDialogVisbility',
    ]),
    plural(number, phrases) {
      return getPlural(number, phrases);
    },
    closeDialog() {
      this.setDialogVisbility(false);
    },
  },
};
</script>
